import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics'

export const isNativeApp = Capacitor.isNativePlatform()
export const isArcadeApp = isNativeApp || import.meta.env.VITE_YBG_ARCADE_APP === 'true'

export async function hapticSelection() {
  if (!isNativeApp) return
  await Haptics.selectionChanged().catch(() => undefined)
}

export async function hapticMove(captureCount = 0) {
  if (!isNativeApp) return
  if (captureCount > 0) {
    await Haptics.notification({ type: NotificationType.Success }).catch(() => undefined)
    return
  }
  await Haptics.impact({ style: ImpactStyle.Light }).catch(() => undefined)
}
